var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500", "max-height": "500" },
      model: {
        value: _vm.showRedirectDialog,
        callback: function ($$v) {
          _vm.showRedirectDialog = $$v
        },
        expression: "showRedirectDialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { tile: "", elevated: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "mb-4", attrs: { elevated: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                [
                  _c("v-card-title", { staticClass: "white--text" }, [
                    _vm._v(" Order Grid has Moved! "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-card-text", { staticClass: "black--text" }, [
            _vm._v(
              " Order Grid has moved to our new Alliance Retailer Site. Click below to be redirected. "
            ),
          ]),
          _c(
            "v-card-actions",
            { staticClass: "justify-center pb-4" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: {
                    href: _vm.newSiteUrl,
                    color: "primary",
                    depressed: "",
                  },
                },
                [_vm._v(" Go to new site ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }